import { IApiPerson, IPerson } from '../interface/IPerson'

export default class PersonTransformer {
  public static transform(apiPerson: IApiPerson): IPerson {
    return {
      // fallback for old use of activity_ids
      activityIds: apiPerson.activity_ids.map(item => item.activity_id),
      activityIdsWithDuration: apiPerson.activity_ids.map(item => ({
        activityId: item.activity_id,
        duration: item.duration
      })),
      id: apiPerson.id,
      firstName: apiPerson.first_name,
      lastName: apiPerson.last_name,
      isCabine: apiPerson.is_cabine,
      isDeleted: apiPerson.is_deleted,
      avatar: apiPerson.avatar,
      schemaWeeks: apiPerson.schema_weeks,
      isVisibleInCalender: apiPerson.is_visible_in_calendar,
      isVisibleOnline: apiPerson.is_visible_online,
    }
  }
}
